import { render, staticRenderFns } from "./dataset-list.vue?vue&type=template&id=1533be62"
import script from "./dataset-list.vue?vue&type=script&lang=js"
export * from "./dataset-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./dataset-list.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DatasetListActions: require('/app/ui/public/components/dataset/dataset-list-actions.vue').default,LayoutActionsButton: require('/app/ui/public/components/layout/layout-actions-button.vue').default,SearchFilters: require('/app/ui/public/components/search/search-filters.vue').default,DatasetCard: require('/app/ui/public/components/dataset/dataset-card.vue').default,DatasetListItem: require('/app/ui/public/components/dataset/dataset-list-item.vue').default,SearchProgress: require('/app/ui/public/components/search/search-progress.vue').default,LayoutWrapSvg: require('/app/ui/public/components/layout/layout-wrap-svg.vue').default,DatasetFacets: require('/app/ui/public/components/dataset/dataset-facets.vue').default,LayoutNavigationRight: require('/app/ui/public/components/layout/layout-navigation-right.vue').default})
